import { useAuth0 } from "@auth0/auth0-react";
import { useEnsureUser } from "./useEnsureUser";
import { resolveAdEligibility } from "@/lib/adsense";

export function useAdEligibility() {
  const { isAuthenticated, isLoading: authLoading } = useAuth0();
  const { data: user, isLoading: userLoading } = useEnsureUser();

  return resolveAdEligibility({
    authLoading,
    isAuthenticated,
    userLoading,
    adsEnabled: user?.entitlements.adsEnabled,
  });
}
